import { css } from 'styled-components';

export const base = css`
  display: flex;
`;

export const inline = css`
  display: inline-flex;
`;
